import { useRef } from "react";

export default function Lights(
  props: JSX.IntrinsicElements["directionalLight"]
) {
  const directionalLightRef = useRef();
  // useHelper(directionalLightRef, DirectionalLightHelper, 1);

  const pointLightRef = useRef();
  // useHelper(directionalLightRef, PointLightHelper, 1);

  return (
    <>
      <ambientLight intensity={0.3} />
      <directionalLight
        ref={directionalLightRef}
        position={[3, 3, 3]}
        intensity={3}
        // shadow-mapSize-width={2048}
        // shadow-mapSize-height={2048}
        // shadow-camera-far={5}
        // shadow-camera-top={5}
        // shadow-camera-right={5}
        // shadow-camera-bottom={-5}
        // shadow-camera-left={-5}
        {...props}
      />
      <pointLight ref={pointLightRef} position={[0, 0, 5]} intensity={4.5} />
    </>
  );
}
